<markant-dialog #UserDialog [open]="this.dialogState" critical="true">
  <mat-card *ngIf="user$ | async as u" class="userCard">
    <mat-card-title class="username">{{ u.firstName }} {{ u.lastName }} ({{ u.mnetId }})</mat-card-title>
    <mat-card-content>
      <form [formGroup]="userForm">
        <div class="row rowOverride">
          <mat-form-field class="col-12 col-md-4">
            <mat-label>Ansprache</mat-label>
            <mat-select formControlName="title">
              <mat-option [value]="Title.MALE">Herr</mat-option>
              <mat-option [value]="Title.FEMALE">Frau</mat-option>
              <mat-option [value]="Title.DIVERSE">Keine Anrede</mat-option>
            </mat-select>
            <mat-hint *ngIf="(differences$ | async)?.title as diff" class="difference">
              <span class="mnet">MNET: </span><strong>{{ diff }}</strong>
            </mat-hint>
          </mat-form-field>
          <mat-form-field class="col-6 col-md-4">
            <mat-label>Vorname</mat-label>
            <mat-hint *ngIf="(differences$ | async)?.firstName as diff" class="difference">
              <span class="mnet">MNET: </span><strong>{{ diff }}</strong>
            </mat-hint>
            <input matInput type="text" formControlName="firstName" />
          </mat-form-field>

          <mat-form-field class="col-6 col-md-4">
            <mat-label>Nachname</mat-label>
            <input matInput type="text" formControlName="lastName" />
            <mat-hint *ngIf="(differences$ | async)?.lastName as diff" class="difference">
              <span class="mnet">MNET: </span><strong>{{ diff }}</strong>
            </mat-hint>
          </mat-form-field>

          <mat-form-field class="col-6 col-md-6">
            <mat-label>E-Mail</mat-label>
            <input matInput type="text" formControlName="email" />
            <mat-hint *ngIf="(differences$ | async)?.email as diff" class="difference">
              <span class="mnet">MNET: </span><strong>{{ diff }}</strong>
            </mat-hint>
          </mat-form-field>

          <mat-form-field class="col-6 col-md-6">
            <mat-label>Telefon</mat-label>
            <input type="text" matInput formControlName="phone" />
            <mat-hint *ngIf="(differences$ | async)?.phone as diff" class="difference">
              <span class="mnet">MNET: </span><strong>{{ diff }}</strong>
            </mat-hint>
          </mat-form-field>

          <mat-form-field class="col-6 col-md-3">
            <mat-label>Benutzergruppe</mat-label>
            <mat-select formControlName="userType" [disabled]="true">
              <mat-option *ngFor="let u of this.UserType | keyvalue" [value]="u.key">{{ u.value }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="col-6 col-md-3">
            <mat-label>Berechtigung</mat-label>
            <mat-select id="userPrivilege" ngDefaultControl formControlName="userPrivilege" [value]="u.userPrivilege" [disabled]="hasToBeDisabled()">
              <mat-option *ngFor="let u of this.UserPrivilege | keyvalue" [value]="u.key">{{ u.value }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        @if (u.lastSeen) {
          <div class="col-6 extra-info">
            <div>
              <div>zuletzt gesehen:</div>
              <div>{{ u?.lastSeen | date: 'short' }}</div>
            </div>
            <div *ngIf="u.permissions.length > 0">
              <div>Berechtigungen</div>
              <div *ngFor="let p of u.permissions">{{ p }}</div>
            </div>
          </div>
        }
      </form>

      <!-- TODO: Extra Informationen wie lastSeen + Links zu Startup etc einfügen? -->
    </mat-card-content>
    <mat-card-actions style="display: flex; justify-content: space-between">
      <markant-button (click)="cancel()" class="blue button">Abbrechen</markant-button>
      <div style="flex-grow: 100"></div>
      <markant-button class="pink primary button" (click)="save(u.id)">Speichern</markant-button>
    </mat-card-actions>
  </mat-card>
</markant-dialog>
